var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgBlurHero02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 831,
    viewBox: "0 0 1176 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_336_9622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 627.5,
    cy: 479.876,
    rx: 126.5,
    ry: 89.876,
    fill: "url(#paint0_linear_336_9622)",
    fillOpacity: 0.92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_336_9622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 705.5,
    cy: 447.5,
    rx: 300.5,
    ry: 213.5,
    fill: "url(#paint1_linear_336_9622)",
    fillOpacity: 0.53
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_336_9622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.941 173.149C579.184 220.055 583.295 365.031 507.125 496.962C430.954 628.894 303.345 697.821 222.103 650.916C140.86 604.01 136.749 459.034 212.919 327.103C289.09 195.171 416.699 126.244 497.941 173.149Z",
    fill: "url(#paint2_linear_336_9622)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_336_9622",
    x: 381,
    y: 270,
    width: 493,
    height: 419.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_336_9622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_336_9622",
    x: 235,
    y: 64,
    width: 941,
    height: 767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 85,
    result: "effect1_foregroundBlur_336_9622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_336_9622",
    x: 0.375732,
    y: 0.431946,
    width: 719.292,
    height: 823.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79,
    result: "effect1_foregroundBlur_336_9622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_9622",
    x1: 601.276,
    y1: 432.476,
    x2: 676.038,
    y2: 583.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_9622",
    x1: 643.205,
    y1: 334.902,
    x2: 820.801,
    y2: 694.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_9622",
    x1: 217.338,
    y1: 461.46,
    x2: 614.087,
    y2: 514.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11A5D4",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlurHero02);
export default __webpack_public_path__ + "static/media/bg_blur-hero-02.ce4124f9568be3043df634576bfdd476.svg";
export { ForwardRef as ReactComponent };